export default __webpack_public_path__ + "static/media/Hood of Concealing Shadows.476c328b.jpg";